import type { PartiesConfig } from '../../../domain/types/configs/company/PartiesConfig';

export const partiesConfig: PartiesConfig = {
  notify: [
    {
      accountNumber: "Other",
      contacts: [],
      address: {
        cityName: "-",
        country: "-",
        postalCode: "-",
        addressLine2: "-",
        city: "-",
        stateProvince: "-",
        countryName: "-",
        addressLine1: "-"
      },
      name: "Other"
    },
    {
      address: {
        addressLine1: "-",
        cityName: "-",
        postalCode: "-",
        city: "-",
        stateProvince: "-",
        countryName: "-",
        country: "-",
        addressLine2: "-"
      },
      accountNumber: "1",
      contacts: [],
      name: "Promocion Medica SA"
    },
    {
      accountNumber: "2",
      contacts: [],
      address: {
        country: "-",
        countryName: "-",
        city: "-",
        cityName: "-",
        addressLine1: "-",
        stateProvince: "-",
        postalCode: "-",
        addressLine2: "-"
      },
      name: "PROMED Medical Care SA"
    },
    {
      address: {
        stateProvince: "-",
        addressLine2: "-",
        cityName: "-",
        city: "-",
        country: "-",
        countryName: "-",
        addressLine1: "-",
        postalCode: "-"
      },
      contacts: [],
      accountNumber: "3",
      name: "PROMED - El Salvador"
    },
    {
      accountNumber: "4",
      address: {
        addressLine2: "-",
        addressLine1: "-",
        city: "-",
        country: "-",
        cityName: "-",
        countryName: "-",
        postalCode: "-",
        stateProvince: "-"
      },
      name: "PROMED - Costa Rica",
      contacts: []
    },
    {
      contacts: [],
      address: {
        stateProvince: "-",
        addressLine2: "-",
        country: "-",
        cityName: "-",
        countryName: "-",
        postalCode: "-",
        city: "-",
        addressLine1: "-"
      },
      accountNumber: "5",
      name: "PROMED - Guatemala"
    },
    {
      name: "PROMED - Honduras",
      contacts: [],
      accountNumber: "6",
      address: {
        stateProvince: "-",
        cityName: "-",
        city: "-",
        addressLine1: "-",
        postalCode: "-",
        addressLine2: "-",
        country: "-",
        countryName: "-"
      }
    },
    {
      name: "PROMED - Nicaragua",
      accountNumber: "7",
      contacts: [],
      address: {
        countryName: "-",
        addressLine1: "-",
        addressLine2: "-",
        city: "-",
        stateProvince: "-",
        postalCode: "-",
        cityName: "-",
        country: "-"
      }
    },
    {
      address: {
        cityName: "-",
        stateProvince: "-",
        countryName: "-",
        addressLine1: "-",
        country: "-",
        addressLine2: "-",
        city: "-",
        postalCode: "-"
      },
      accountNumber: "8",
      contacts: [],
      name: "LAMEX Republica Dominicana"
    },
    {
      contacts: [],
      accountNumber: "9",
      name: "PROMED Medical Logistics",
      address: {
        country: "-",
        cityName: "-",
        postalCode: "-",
        countryName: "-",
        city: "-",
        addressLine2: "-",
        addressLine1: "-",
        stateProvince: "-"
      }
    }
  ],
  delivery: [
    {
      contacts: [],
      accountNumber: "Other",
      address: {
        country: "-",
        addressLine1: "-",
        stateProvince: "-",
        cityName: "-",
        countryName: "-",
        addressLine2: "-",
        city: "-",
        postalCode: "-"
      },
      name: "Other"
    },
    {
      accountNumber: "1",
      address: {
        country: "-",
        addressLine1: "-",
        stateProvince: "-",
        city: "-",
        addressLine2: "-",
        cityName: "-",
        postalCode: "-",
        countryName: "-"
      },
      name: "Promocion Medica SA",
      contacts: []
    },
    {
      contacts: [],
      address: {
        cityName: "-",
        city: "-",
        postalCode: "-",
        countryName: "-",
        addressLine2: "-",
        addressLine1: "-",
        stateProvince: "-",
        country: "-"
      },
      accountNumber: "2",
      name: "PROMED Medical Care SA"
    },
    {
      name: "PROMED - El Salvador",
      accountNumber: "3",
      contacts: [],
      address: {
        stateProvince: "-",
        addressLine2: "-",
        country: "-",
        countryName: "-",
        addressLine1: "-",
        cityName: "-",
        postalCode: "-",
        city: "-"
      }
    },
    {
      address: {
        city: "-",
        addressLine1: "-",
        country: "-",
        cityName: "-",
        addressLine2: "-",
        postalCode: "-",
        countryName: "-",
        stateProvince: "-"
      },
      name: "PROMED - Costa Rica",
      contacts: [],
      accountNumber: "4"
    },
    {
      name: "PROMED - Guatemala",
      accountNumber: "5",
      address: {
        addressLine1: "-",
        postalCode: "-",
        cityName: "-",
        stateProvince: "-",
        country: "-",
        city: "-",
        addressLine2: "-",
        countryName: "-"
      },
      contacts: []
    },
    {
      name: "PROMED - Honduras",
      address: {
        city: "-",
        cityName: "-",
        addressLine1: "-",
        country: "-",
        addressLine2: "-",
        postalCode: "-",
        countryName: "-",
        stateProvince: "-"
      },
      contacts: [],
      accountNumber: "6"
    },
    {
      contacts: [],
      name: "PROMED Nicaragua",
      address: {
        country: "-",
        postalCode: "-",
        countryName: "-",
        addressLine1: "-",
        addressLine2: "-",
        city: "-",
        cityName: "-",
        stateProvince: "-"
      },
      accountNumber: "7"
    },
    {
      contacts: [],
      name: "LAMEX Republica Dominicana",
      address: {
        cityName: "-",
        addressLine1: "-",
        addressLine2: "-",
        city: "-",
        countryName: "-",
        stateProvince: "-",
        country: "-",
        postalCode: "-"
      },
      accountNumber: "8"
    },
    {
      address: {
        postalCode: "-",
        addressLine2: "-",
        countryName: "-",
        city: "-",
        country: "-",
        cityName: "-",
        stateProvince: "-",
        addressLine1: "-"
      },
      contacts: [],
      name: "PROMED Medical Logistics",
      accountNumber: "9"
    },
    {
      name: "TLA LOGISTICS",
      accountNumber: "10",
      address: {
        stateProvince: "-",
        city: "-",
        addressLine2: "-",
        postalCode: "-",
        country: "-",
        countryName: "-",
        addressLine1: "-",
        cityName: "-"
      },
      contacts: []
    },
    {
      address: {
        addressLine2: "-",
        city: "-",
        country: "-",
        stateProvince: "-",
        cityName: "-",
        countryName: "-",
        postalCode: "-",
        addressLine1: "-"
      },
      contacts: [],
      accountNumber: "11",
      name: "ALLIANCE TRANSPORT LOGISTICS"
    },
    {
      address: {
        stateProvince: "-",
        country: "-",
        city: "-",
        cityName: "-",
        addressLine2: "-",
        countryName: "-",
        addressLine1: "-",
        postalCode: "-"
      },
      name: "PANAMA COLD AGENCY",
      accountNumber: "12",
      contacts: []
    },
    {
      accountNumber: "13",
      address: {
        stateProvince: "-",
        postalCode: "-",
        countryName: "-",
        city: "-",
        addressLine1: "-",
        country: "-",
        addressLine2: "-",
        cityName: "-"
      },
      contacts: [],
      name: "RB COLD CHAIN"
    }
  ],
  pickup: [
    {
      name: "Other",
      address: {
        cityName: "-",
        addressLine2: "-",
        country: "-",
        countryName: "-",
        addressLine1: "-",
        stateProvince: "-",
        postalCode: "-",
        city: "-"
      },
      contacts: [],
      accountNumber: "Other"
    },
    {
      accountNumber: "01",
      contacts: [],
      address: {
        addressLine1: "-",
        cityName: "-",
        stateProvince: "-",
        postalCode: "-",
        country: "-",
        countryName: "-",
        addressLine2: "-",
        city: "-"
      },
      name: "ALDRICH CHEMICAL CORP"
    },
    {
      contacts: [],
      address: {
        stateProvince: "-",
        addressLine1: "-",
        countryName: "-",
        addressLine2: "-",
        country: "-",
        city: "-",
        cityName: "-",
        postalCode: "-"
      },
      accountNumber: "02",
      name: "AMPRONIX"
    },
    {
      contacts: [],
      name: "ARKRAY",
      accountNumber: "03",
      address: {
        addressLine1: "-",
        stateProvince: "-",
        countryName: "-",
        cityName: "-",
        city: "-",
        postalCode: "-",
        addressLine2: "-",
        country: "-"
      }
    },
    {
      address: {
        country: "-",
        countryName: "-",
        postalCode: "-",
        city: "-",
        addressLine1: "-",
        cityName: "-",
        addressLine2: "-",
        stateProvince: "-"
      },
      name: "ASP",
      accountNumber: "04",
      contacts: []
    },
    {
      address: {
        cityName: "-",
        city: "-",
        addressLine2: "-",
        country: "-",
        addressLine1: "-",
        postalCode: "-",
        countryName: "-",
        stateProvince: "-"
      },
      contacts: [],
      name: "BARCO NV",
      accountNumber: "05"
    },
    {
      address: {
        countryName: "-",
        addressLine2: "-",
        cityName: "-",
        city: "-",
        stateProvince: "-",
        postalCode: "-",
        addressLine1: "-",
        country: "-"
      },
      accountNumber: "06",
      contacts: [],
      name: "BARKEY"
    },
    {
      address: {
        city: "-",
        addressLine1: "-",
        country: "-",
        stateProvince: "-",
        countryName: "-",
        addressLine2: "-",
        postalCode: "-",
        cityName: "-"
      },
      contacts: [],
      name: "BECKMAN COULTER INC ",
      accountNumber: "07"
    },
    {
      contacts: [],
      address: {
        postalCode: "-",
        stateProvince: "-",
        cityName: "-",
        city: "-",
        country: "-",
        addressLine1: "-",
        countryName: "-",
        addressLine2: "-"
      },
      name: "BECTON DICKINSON",
      accountNumber: "08"
    },
    {
      address: {
        stateProvince: "-",
        countryName: "-",
        addressLine1: "-",
        city: "-",
        addressLine2: "-",
        postalCode: "-",
        cityName: "-",
        country: "-"
      },
      contacts: [],
      name: "BOSTON SCIENTIFIC",
      accountNumber: "09"
    },
    {
      name: "BUCHI LABORTECHNIK",
      address: {
        cityName: "-",
        country: "-",
        postalCode: "-",
        addressLine1: "-",
        addressLine2: "-",
        countryName: "-",
        stateProvince: "-",
        city: "-"
      },
      contacts: [],
      accountNumber: "10"
    },
    {
      address: {
        country: "-",
        city: "-",
        postalCode: "-",
        stateProvince: "-",
        addressLine1: "-",
        countryName: "-",
        addressLine2: "-",
        cityName: "-"
      },
      contacts: [],
      accountNumber: "11",
      name: "B MEDICAL SYSTEM"
    },
    {
      accountNumber: "12",
      name: "CEPHEID EUROPE SAS",
      address: {
        city: "-",
        addressLine2: "-",
        countryName: "-",
        cityName: "-",
        stateProvince: "-",
        postalCode: "-",
        addressLine1: "-",
        country: "-"
      },
      contacts: []
    },
    {
      useShipperInformation: false,
      useConsigneeInformation: false,
      accountNumber: "13",
      name: "CERUS EUROPE BV",
      address: {
        addressLine1: "-",
        countryName: "-",
        addressLine2: "-",
        cityName: "-",
        postalCode: "-",
        stateProvince: "-",
        city: "-",
        country: "-"
      },
      contacts: []
    },
    {
      contacts: [],
      accountNumber: "14",
      address: {
        city: "-",
        addressLine2: "-",
        stateProvince: "-",
        postalCode: "-",
        addressLine1: "-",
        countryName: "-",
        cityName: "-",
        country: "-"
      },
      name: "COLD CHAIN TECHNOLOGIES"
    },
    {
      address: {
        country: "-",
        addressLine1: "-",
        countryName: "-",
        city: "-",
        postalCode: "-",
        stateProvince: "-",
        cityName: "-",
        addressLine2: "-"
      },
      accountNumber: "15",
      contacts: [],
      name: "CORPORATIVO BD DE MEXICO S DE RL"
    },
    {
      accountNumber: "16",
      address: {
        stateProvince: "-",
        addressLine2: "-",
        country: "-",
        city: "-",
        addressLine1: "-",
        postalCode: "-",
        cityName: "-",
        countryName: "-"
      },
      contacts: [],
      name: "DEVICOR MEDICAL PRODUCTS, INC."
    },
    {
      accountNumber: "17",
      contacts: [],
      name: "ECLERIS USA",
      address: {
        cityName: "-",
        city: "-",
        addressLine2: "-",
        stateProvince: "-",
        country: "-",
        addressLine1: "-",
        countryName: "-",
        postalCode: "-"
      }
    },
    {
      contacts: [],
      name: "ELITECH GROUP",
      accountNumber: "18",
      address: {
        stateProvince: "-",
        countryName: "-",
        postalCode: "-",
        addressLine2: "-",
        addressLine1: "-",
        cityName: "-",
        city: "-",
        country: "-"
      }
    },
    {
      contacts: [],
      name: "EPPENDORF",
      accountNumber: "19",
      address: {
        city: "-",
        postalCode: "-",
        stateProvince: "-",
        countryName: "-",
        addressLine2: "-",
        addressLine1: "-",
        cityName: "-",
        country: "-"
      }
    },
    {
      contacts: [],
      address: {
        addressLine1: "-",
        country: "-",
        addressLine2: "-",
        postalCode: "-",
        countryName: "-",
        stateProvince: "-",
        cityName: "-",
        city: "-"
      },
      accountNumber: "20",
      name: "FENGH MEDICAL CO"
    },
    {
      address: {
        addressLine1: "-",
        country: "-",
        countryName: "-",
        postalCode: "-",
        stateProvince: "-",
        city: "-",
        addressLine2: "-",
        cityName: "-"
      },
      name: "FRESENIUS KABI",
      contacts: [],
      accountNumber: "21"
    },
    {
      accountNumber: "22",
      address: {
        postalCode: "-",
        countryName: "-",
        cityName: "-",
        stateProvince: "-",
        country: "-",
        city: "-",
        addressLine1: "-",
        addressLine2: "-"
      },
      name: "FRESENIUS MEDICAL CARE",
      contacts: []
    },
    {
      contacts: [],
      name: "GE MEDICAL SYSTEMS",
      accountNumber: "23",
      address: {
        country: "-",
        city: "-",
        countryName: "-",
        stateProvince: "-",
        cityName: "-",
        addressLine1: "-",
        postalCode: "-",
        addressLine2: "-"
      }
    },
    {
      contacts: [],
      name: "GE Precision Healthcare",
      accountNumber: "24",
      address: {
        city: "-",
        countryName: "-",
        addressLine1: "-",
        stateProvince: "-",
        cityName: "-",
        addressLine2: "-",
        postalCode: "-",
        country: "-"
      }
    },
    {
      address: {
        stateProvince: "-",
        countryName: "-",
        postalCode: "-",
        addressLine1: "-",
        cityName: "-",
        country: "-",
        addressLine2: "-",
        city: "-"
      },
      accountNumber: "25",
      name: "GE ULTRASOUND",
      contacts: []
    },
    {
      accountNumber: "26",
      address: {
        cityName: "-",
        city: "-",
        postalCode: "-",
        stateProvince: "-",
        countryName: "-",
        country: "-",
        addressLine2: "-",
        addressLine1: "-"
      },
      contacts: [],
      name: "GRIFOLS"
    },
    {
      contacts: [],
      address: {
        postalCode: "-",
        addressLine1: "-",
        addressLine2: "-",
        countryName: "-",
        stateProvince: "-",
        cityName: "-",
        city: "-",
        country: "-"
      },
      name: "HAEMONETICS CORPORATION",
      accountNumber: "27"
    },
    {
      address: {
        addressLine1: "-",
        cityName: "-",
        addressLine2: "-",
        country: "-",
        countryName: "-",
        stateProvince: "-",
        city: "-",
        postalCode: "-"
      },
      name: "Instrumentation Laboratory",
      contacts: [],
      accountNumber: "28"
    },
    {
      contacts: [],
      accountNumber: "29",
      name: "isotech",
      address: {
        postalCode: "-",
        cityName: "-",
        stateProvince: "-",
        addressLine2: "-",
        country: "-",
        countryName: "-",
        city: "-",
        addressLine1: "-"
      }
    },
    {
      contacts: [],
      name: "Jeol USA",
      accountNumber: "30",
      address: {
        cityName: "-",
        country: "-",
        stateProvince: "-",
        addressLine2: "-",
        postalCode: "-",
        countryName: "-",
        city: "-",
        addressLine1: "-"
      }
    },
    {
      name: "K&S ASSOCIATES, INC",
      accountNumber: "31",
      contacts: [],
      address: {
        city: "-",
        countryName: "-",
        cityName: "-",
        country: "-",
        addressLine1: "-",
        stateProvince: "-",
        addressLine2: "-",
        postalCode: "-"
      }
    },
    {
      contacts: [],
      address: {
        stateProvince: "-",
        countryName: "-",
        cityName: "-",
        addressLine2: "-",
        country: "-",
        city: "-",
        addressLine1: "-",
        postalCode: "-"
      },
      accountNumber: "32",
      name: "KARL STORZ"
    },
    {
      accountNumber: "33",
      contacts: [],
      address: {
        addressLine2: "-",
        stateProvince: "-",
        cityName: "-",
        postalCode: "-",
        addressLine1: "-",
        countryName: "-",
        city: "-",
        country: "-"
      },
      name: "KARL STORZ ENDOSCOPIA MEXICO"
    },
    {
      name: "KENKAR",
      contacts: [],
      accountNumber: "34",
      address: {
        postalCode: "-",
        country: "-",
        cityName: "-",
        addressLine1: "-",
        countryName: "-",
        stateProvince: "-",
        addressLine2: "-",
        city: "-"
      }
    },
    {
      name: "LABORIE",
      accountNumber: "35",
      contacts: [],
      address: {
        addressLine1: "-",
        country: "-",
        addressLine2: "-",
        postalCode: "-",
        cityName: "-",
        city: "-",
        countryName: "-",
        stateProvince: "-"
      }
    },
    {
      name: "LEXINGTON MEDICAL",
      contacts: [],
      accountNumber: "36",
      address: {
        postalCode: "-",
        country: "-",
        cityName: "-",
        countryName: "-",
        stateProvince: "-",
        addressLine1: "-",
        addressLine2: "-",
        city: "-"
      }
    },
    {
      contacts: [],
      address: {
        stateProvince: "-",
        cityName: "-",
        city: "-",
        countryName: "-",
        addressLine1: "-",
        addressLine2: "-",
        postalCode: "-",
        country: "-"
      },
      accountNumber: "4751519404",
      name: "LIFE CORPORATION"
    },
    {
      contacts: [],
      accountNumber: "38",
      address: {
        cityName: "-",
        postalCode: "-",
        addressLine2: "-",
        addressLine1: "-",
        stateProvince: "-",
        country: "-",
        city: "-",
        countryName: "-"
      },
      name: "MEDIMAPS GROUP"
    },
    {
      accountNumber: "39",
      address: {
        postalCode: "-",
        stateProvince: "-",
        addressLine1: "-",
        country: "-",
        city: "-",
        addressLine2: "-",
        countryName: "-",
        cityName: "-"
      },
      name: "MET ONE",
      contacts: []
    },
    {
      accountNumber: "40",
      contacts: [],
      address: {
        city: "-",
        postalCode: "-",
        addressLine2: "-",
        stateProvince: "-",
        country: "-",
        cityName: "-",
        addressLine1: "-",
        countryName: "-"
      },
      name: "NATUS MEDICAL INCORPORATED"
    },
    {
      name: "PROMED MEDICAL CARE",
      address: {
        addressLine1: "-",
        postalCode: "-",
        cityName: "-",
        addressLine2: "-",
        countryName: "-",
        stateProvince: "-",
        country: "-",
        city: "-"
      },
      contacts: [],
      accountNumber: "41"
    },
    {
      accountNumber: "42",
      contacts: [],
      name: "PROMOCIÓN MÉDICA S.A.",
      address: {
        stateProvince: "-",
        city: "-",
        country: "-",
        addressLine2: "-",
        cityName: "-",
        countryName: "-",
        postalCode: "-",
        addressLine1: "-"
      }
    },
    {
      contacts: [],
      address: {
        postalCode: "-",
        addressLine2: "-",
        city: "-",
        countryName: "-",
        country: "-",
        cityName: "-",
        addressLine1: "-",
        stateProvince: "-"
      },
      accountNumber: "43",
      name: "STERIS"
    },
    {
      address: {
        cityName: "-",
        stateProvince: "-",
        countryName: "-",
        country: "-",
        city: "-",
        addressLine2: "-",
        postalCode: "-",
        addressLine1: "-"
      },
      contacts: [],
      accountNumber: "44",
      name: "STORZ MEDICAL"
    },
    {
      contacts: [],
      accountNumber: "45",
      address: {
        cityName: "-",
        postalCode: "-",
        addressLine2: "-",
        country: "-",
        addressLine1: "-",
        city: "-",
        countryName: "-",
        stateProvince: "-"
      },
      name: "SYSTEC"
    },
    {
      contacts: [],
      accountNumber: "46",
      address: {
        postalCode: "-",
        cityName: "-",
        stateProvince: "-",
        addressLine1: "-",
        country: "-",
        addressLine2: "-",
        city: "-",
        countryName: "-"
      },
      name: "Taiwan Surgical Corporation"
    },
    {
      contacts: [],
      name: "THERMO FISHER SCIENTIFIC",
      address: {
        addressLine2: "-",
        countryName: "-",
        stateProvince: "-",
        addressLine1: "-",
        country: "-",
        cityName: "-",
        city: "-",
        postalCode: "-"
      },
      accountNumber: "47"
    },
    {
      name: "ULRICH GMBH",
      contacts: [],
      accountNumber: "48",
      address: {
        stateProvince: "-",
        countryName: "-",
        cityName: "-",
        country: "-",
        city: "-",
        addressLine2: "-",
        addressLine1: "-",
        postalCode: "-"
      }
    },
    {
      contacts: [],
      name: "VYAIRE",
      accountNumber: "49",
      address: {
        countryName: "-",
        postalCode: "-",
        country: "-",
        addressLine1: "-",
        city: "-",
        cityName: "-",
        stateProvince: "-",
        addressLine2: "-"
      }
    }
  ],
  shipper: [
    {
      accountNumber: "Other",
      contacts: [],
      name: "Other",
      address: {
        countryName: "-",
        stateProvince: "-",
        cityName: "-",
        addressLine2: "-",
        country: "-",
        addressLine1: "-",
        postalCode: "-",
        city: "-"
      }
    },
    {
      accountNumber: "01",
      address: {
        cityName: "Barranquilla",
        addressLine2: "-",
        countryName: "Colombia",
        postalCode: "-",
        country: "CO",
        city: "BAQ",
        addressLine1: "-",
        stateProvince: "-"
      },
      name: "ALDRICH CHEMICAL CORP",
      contacts: []
    },
    {
      address: {
        addressLine2: "-",
        addressLine1: "-",
        cityName: "-",
        countryName: "-",
        stateProvince: "-",
        city: "-",
        postalCode: "-",
        country: "-"
      },
      accountNumber: "02",
      name: "AMPRONIX",
      contacts: []
    },
    {
      contacts: [],
      accountNumber: "03",
      address: {
        country: "-",
        addressLine1: "-",
        addressLine2: "-",
        postalCode: "-",
        countryName: "-",
        city: "-",
        cityName: "-",
        stateProvince: "-"
      },
      name: "ARKRAY"
    },
    {
      address: {
        countryName: "-",
        stateProvince: "-",
        cityName: "-",
        city: "-",
        country: "-",
        addressLine1: "-",
        addressLine2: "-",
        postalCode: "-"
      },
      contacts: [],
      name: "ASP",
      accountNumber: "04"
    },
    {
      contacts: [],
      address: {
        stateProvince: "-",
        city: "-",
        addressLine2: "-",
        postalCode: "-",
        addressLine1: "-",
        countryName: "-",
        country: "-",
        cityName: "-"
      },
      accountNumber: "05",
      name: "BARCO NV"
    },
    {
      contacts: [],
      accountNumber: "06",
      address: {
        cityName: "-",
        country: "-",
        postalCode: "-",
        countryName: "-",
        addressLine2: "-",
        addressLine1: "-",
        city: "-",
        stateProvince: "-"
      },
      name: "BARKEY"
    },
    {
      accountNumber: "07",
      address: {
        postalCode: "-",
        stateProvince: "-",
        country: "-",
        countryName: "-",
        city: "-",
        addressLine2: "-",
        cityName: "-",
        addressLine1: "-"
      },
      name: "BECKMAN COULTER INC ",
      contacts: []
    },
    {
      accountNumber: "08",
      contacts: [],
      address: {
        city: "-",
        addressLine1: "-",
        addressLine2: "-",
        cityName: "-",
        country: "-",
        postalCode: "-",
        stateProvince: "-",
        countryName: "-"
      },
      name: "BECTON DICKINSON"
    },
    {
      accountNumber: "09",
      address: {
        postalCode: "-",
        city: "-",
        addressLine1: "-",
        countryName: "-",
        country: "-",
        addressLine2: "-",
        cityName: "-",
        stateProvince: "-"
      },
      contacts: [],
      name: "BOSTON SCIENTIFIC"
    },
    {
      name: "BUCHI LABORTECHNIK",
      address: {
        country: "-",
        countryName: "-",
        addressLine1: "-",
        city: "-",
        postalCode: "-",
        cityName: "-",
        stateProvince: "-",
        addressLine2: "-"
      },
      accountNumber: "10",
      contacts: []
    },
    {
      accountNumber: "11",
      address: {
        addressLine1: "-",
        addressLine2: "-",
        city: "-",
        countryName: "-",
        postalCode: "-",
        stateProvince: "-",
        cityName: "-",
        country: "-"
      },
      contacts: [],
      name: "B MEDICAL SYSTEM"
    },
    {
      name: "CEPHEID EUROPE SAS",
      contacts: [],
      accountNumber: "12",
      address: {
        city: "-",
        cityName: "-",
        country: "-",
        postalCode: "-",
        addressLine1: "-",
        countryName: "-",
        addressLine2: "-",
        stateProvince: "-"
      }
    },
    {
      name: "CERUS EUROPE BV",
      address: {
        addressLine2: "-",
        country: "-",
        countryName: "-",
        postalCode: "-",
        city: "-",
        stateProvince: "-",
        cityName: "-",
        addressLine1: "-"
      },
      contacts: [],
      accountNumber: "13"
    },
    {
      address: {
        stateProvince: "-",
        city: "-",
        cityName: "-",
        addressLine2: "-",
        postalCode: "-",
        addressLine1: "-",
        country: "-",
        countryName: "-"
      },
      name: "COLD CHAIN TECHNOLOGIES",
      accountNumber: "14",
      contacts: []
    },
    {
      name: "CORPORATIVO BD DE MEXICO S DE RL",
      address: {
        postalCode: "-",
        countryName: "-",
        cityName: "-",
        addressLine2: "-",
        stateProvince: "-",
        addressLine1: "-",
        city: "-",
        country: "-"
      },
      contacts: [],
      accountNumber: "15"
    },
    {
      accountNumber: "16",
      contacts: [],
      address: {
        country: "-",
        city: "-",
        cityName: "-",
        postalCode: "-",
        countryName: "-",
        addressLine1: "-",
        stateProvince: "-",
        addressLine2: "-"
      },
      name: "DEVICOR MEDICAL PRODUCTS, INC."
    },
    {
      address: {
        country: "-",
        addressLine2: "-",
        cityName: "-",
        stateProvince: "-",
        postalCode: "-",
        addressLine1: "-",
        city: "-",
        countryName: "-"
      },
      contacts: [],
      accountNumber: "17",
      name: "ECLERIS USA"
    },
    {
      accountNumber: "18",
      contacts: [],
      name: "ELITECH GROUP",
      address: {
        country: "-",
        countryName: "-",
        stateProvince: "-",
        city: "-",
        postalCode: "-",
        addressLine1: "-",
        addressLine2: "-",
        cityName: "-"
      }
    },
    {
      contacts: [],
      address: {
        addressLine1: "-",
        cityName: "-",
        city: "-",
        countryName: "-",
        stateProvince: "-",
        country: "-",
        postalCode: "-",
        addressLine2: "-"
      },
      accountNumber: "19",
      name: "EPPENDORF"
    },
    {
      address: {
        addressLine1: "-",
        addressLine2: "-",
        countryName: "-",
        stateProvince: "-",
        postalCode: "-",
        country: "-",
        cityName: "-",
        city: "-"
      },
      name: "FENGH MEDICAL CO",
      contacts: [],
      accountNumber: "20"
    },
    {
      accountNumber: "21",
      contacts: [],
      name: "FRESENIUS KABI",
      address: {
        stateProvince: "-",
        country: "-",
        addressLine1: "-",
        addressLine2: "-",
        city: "-",
        countryName: "-",
        postalCode: "-",
        cityName: "-"
      }
    },
    {
      contacts: [],
      name: "FRESENIUS MEDICAL CARE",
      accountNumber: "22",
      address: {
        addressLine2: "-",
        countryName: "-",
        postalCode: "-",
        city: "-",
        cityName: "-",
        stateProvince: "-",
        addressLine1: "-",
        country: "-"
      }
    },
    {
      contacts: [],
      address: {
        postalCode: "-",
        addressLine1: "-",
        country: "-",
        city: "-",
        countryName: "-",
        addressLine2: "-",
        stateProvince: "-",
        cityName: "-"
      },
      name: "GE MEDICAL SYSTEMS",
      accountNumber: "23"
    },
    {
      accountNumber: "24",
      contacts: [],
      address: {
        addressLine2: "-",
        city: "-",
        country: "-",
        cityName: "-",
        countryName: "-",
        postalCode: "-",
        addressLine1: "-",
        stateProvince: "-"
      },
      name: "GE Precision Healthcare"
    },
    {
      name: "GE ULTRASOUND",
      accountNumber: "25",
      contacts: [],
      address: {
        addressLine2: "-",
        postalCode: "-",
        cityName: "-",
        addressLine1: "-",
        countryName: "-",
        stateProvince: "-",
        country: "-",
        city: "-"
      }
    },
    {
      accountNumber: "26",
      contacts: [],
      address: {
        addressLine2: "-",
        country: "-",
        addressLine1: "-",
        postalCode: "-",
        countryName: "-",
        cityName: "-",
        city: "-",
        stateProvince: "-"
      },
      name: "GRIFOLS"
    },
    {
      contacts: [],
      address: {
        stateProvince: "-",
        addressLine2: "-",
        city: "-",
        cityName: "-",
        postalCode: "-",
        countryName: "-",
        country: "-",
        addressLine1: "-"
      },
      accountNumber: "27",
      name: "HAEMONETICS CORPORATION"
    },
    {
      contacts: [],
      accountNumber: "28",
      name: "Instrumentation Laboratory",
      address: {
        cityName: "-",
        stateProvince: "-",
        addressLine2: "-",
        city: "-",
        addressLine1: "-",
        countryName: "-",
        country: "-",
        postalCode: "-"
      }
    },
    {
      name: "isotech",
      address: {
        cityName: "-",
        stateProvince: "-",
        postalCode: "-",
        addressLine1: "-",
        countryName: "-",
        country: "-",
        addressLine2: "-",
        city: "-"
      },
      accountNumber: "29",
      contacts: []
    },
    {
      address: {
        postalCode: "-",
        addressLine1: "-",
        city: "-",
        stateProvince: "-",
        country: "-",
        addressLine2: "-",
        cityName: "-",
        countryName: "-"
      },
      accountNumber: "30",
      contacts: [],
      name: "Jeol USA"
    },
    {
      accountNumber: "31",
      name: "K&S ASSOCIATES, INC",
      contacts: [],
      address: {
        addressLine2: "-",
        postalCode: "-",
        stateProvince: "-",
        country: "-",
        cityName: "-",
        countryName: "-",
        city: "-",
        addressLine1: "-"
      }
    },
    {
      accountNumber: "32",
      name: "KARL STORZ",
      contacts: [],
      address: {
        country: "-",
        addressLine1: "-",
        cityName: "-",
        city: "-",
        stateProvince: "-",
        addressLine2: "-",
        postalCode: "-",
        countryName: "-"
      }
    },
    {
      accountNumber: "33",
      address: {
        cityName: "-",
        addressLine2: "-",
        country: "-",
        countryName: "-",
        postalCode: "-",
        stateProvince: "-",
        addressLine1: "-",
        city: "-"
      },
      contacts: [],
      name: "KARL STORZ ENDOSCOPIA MEXICO"
    },
    {
      name: "KENKAR",
      address: {
        cityName: "-",
        stateProvince: "-",
        addressLine2: "-",
        countryName: "-",
        addressLine1: "-",
        postalCode: "-",
        city: "-",
        country: "-"
      },
      contacts: [],
      accountNumber: "34"
    },
    {
      accountNumber: "35",
      contacts: [],
      name: "LABORIE",
      address: {
        stateProvince: "-",
        addressLine1: "-",
        city: "-",
        countryName: "-",
        cityName: "-",
        postalCode: "-",
        addressLine2: "-",
        country: "-"
      }
    },
    {
      contacts: [],
      name: "LEXINGTON MEDICAL",
      address: {
        addressLine1: "-",
        addressLine2: "-",
        postalCode: "-",
        cityName: "-",
        country: "-",
        countryName: "-",
        city: "-",
        stateProvince: "-"
      },
      accountNumber: "36"
    },
    {
      name: "LIFE CORPORATION",
      address: {
        cityName: "-",
        addressLine1: "-",
        stateProvince: "-",
        postalCode: "-",
        addressLine2: "-",
        country: "-",
        city: "-",
        countryName: "-"
      },
      accountNumber: "4751519404",
      contacts: []
    },
    {
      name: "MEDIMAPS GROUP",
      address: {
        cityName: "-",
        addressLine2: "-",
        addressLine1: "-",
        stateProvince: "-",
        postalCode: "-",
        countryName: "-",
        country: "-",
        city: "-"
      },
      accountNumber: "38",
      contacts: []
    },
    {
      name: "MET ONE",
      accountNumber: "39",
      address: {
        cityName: "-",
        stateProvince: "-",
        addressLine1: "-",
        postalCode: "-",
        countryName: "-",
        country: "-",
        addressLine2: "-",
        city: "-"
      },
      contacts: []
    },
    {
      address: {
        addressLine1: "-",
        countryName: "-",
        cityName: "-",
        stateProvince: "-",
        postalCode: "-",
        city: "-",
        addressLine2: "-",
        country: "-"
      },
      accountNumber: "40",
      contacts: [],
      name: "NATUS MEDICAL INCORPORATED"
    },
    {
      contacts: [],
      name: "PROMED MEDICAL CARE",
      accountNumber: "41",
      address: {
        cityName: "-",
        postalCode: "-",
        stateProvince: "-",
        countryName: "-",
        addressLine2: "-",
        addressLine1: "-",
        city: "-",
        country: "-"
      }
    },
    {
      name: "PROMOCIÓN MÉDICA S.A.",
      accountNumber: "42",
      contacts: [],
      address: {
        city: "-",
        addressLine1: "-",
        countryName: "-",
        stateProvince: "-",
        postalCode: "-",
        country: "-",
        addressLine2: "-",
        cityName: "-"
      }
    },
    {
      name: "STERIS",
      address: {
        postalCode: "-",
        countryName: "-",
        stateProvince: "-",
        addressLine1: "-",
        addressLine2: "-",
        city: "-",
        country: "-",
        cityName: "-"
      },
      accountNumber: "43",
      contacts: []
    },
    {
      accountNumber: "44",
      address: {
        addressLine1: "-",
        cityName: "-",
        postalCode: "-",
        addressLine2: "-",
        stateProvince: "-",
        city: "-",
        country: "-",
        countryName: "-"
      },
      contacts: [],
      name: "STORZ MEDICAL"
    },
    {
      contacts: [],
      name: "SYSTEC",
      accountNumber: "45",
      address: {
        postalCode: "-",
        countryName: "-",
        country: "-",
        stateProvince: "-",
        addressLine1: "-",
        cityName: "-",
        city: "-",
        addressLine2: "-"
      }
    },
    {
      name: "Taiwan Surgical Corporation",
      address: {
        addressLine1: "-",
        city: "-",
        cityName: "-",
        postalCode: "-",
        stateProvince: "-",
        country: "-",
        countryName: "-",
        addressLine2: "-"
      },
      contacts: [],
      accountNumber: "46"
    },
    {
      contacts: [],
      accountNumber: "47",
      name: "THERMO FISHER SCIENTIFIC",
      address: {
        addressLine2: "-",
        cityName: "-",
        postalCode: "-",
        countryName: "-",
        city: "-",
        stateProvince: "-",
        addressLine1: "-",
        country: "-"
      }
    },
    {
      contacts: [],
      accountNumber: "48",
      address: {
        addressLine1: "-",
        stateProvince: "-",
        addressLine2: "-",
        countryName: "-",
        cityName: "-",
        city: "-",
        country: "-",
        postalCode: "-"
      },
      name: "ULRICH GMBH"
    },
    {
      name: "VYAIRE",
      contacts: [],
      accountNumber: "49",
      address: {
        addressLine2: "-",
        country: "-",
        city: "-",
        stateProvince: "-",
        cityName: "-",
        postalCode: "-",
        addressLine1: "-",
        countryName: "-"
      }
    }
  ],
  consignee: [
    {
      name: "Other",
      contacts: [],
      accountNumber: "Other",
      address: {
        stateProvince: "-",
        city: "-",
        cityName: "-",
        postalCode: "-",
        addressLine2: "-",
        country: "-",
        countryName: "-",
        addressLine1: "-"
      }
    },
    {
      name: "Promocion Medica SA",
      contacts: [],
      accountNumber: "1",
      address: {
        addressLine1: "-",
        postalCode: "-",
        cityName: "-",
        stateProvince: "-",
        addressLine2: "-",
        country: "-",
        countryName: "-",
        city: "-"
      }
    },
    {
      accountNumber: "2",
      contacts: [],
      address: {
        stateProvince: "-",
        addressLine1: "-",
        addressLine2: "-",
        postalCode: "-",
        countryName: "-",
        cityName: "-",
        country: "-",
        city: "-"
      },
      name: "PROMED Medical Care SA"
    },
    {
      name: "PROMED - El Salvador",
      address: {
        stateProvince: "-",
        addressLine2: "-",
        city: "-",
        addressLine1: "-",
        postalCode: "-",
        countryName: "-",
        cityName: "-",
        country: "-"
      },
      accountNumber: "3",
      contacts: []
    },
    {
      contacts: [],
      name: "PROMED - Costa Rica",
      accountNumber: "4",
      address: {
        cityName: "-",
        addressLine2: "-",
        postalCode: "-",
        countryName: "-",
        city: "-",
        country: "-",
        stateProvince: "-",
        addressLine1: "-"
      }
    },
    {
      contacts: [],
      accountNumber: "5",
      address: {
        stateProvince: "-",
        cityName: "-",
        country: "-",
        city: "-",
        postalCode: "-",
        countryName: "-",
        addressLine1: "-",
        addressLine2: "-"
      },
      name: "PROMED - Guatemala"
    },
    {
      address: {
        countryName: "-",
        country: "-",
        stateProvince: "-",
        city: "-",
        postalCode: "-",
        addressLine2: "-",
        cityName: "-",
        addressLine1: "-"
      },
      name: "PROMED - Honduras",
      accountNumber: "6",
      contacts: []
    },
    {
      name: "PROMED - Nicaragua",
      address: {
        addressLine1: "-",
        cityName: "-",
        postalCode: "-",
        country: "-",
        countryName: "-",
        stateProvince: "-",
        addressLine2: "-",
        city: "-"
      },
      contacts: [],
      accountNumber: "7"
    },
    {
      accountNumber: "8",
      address: {
        country: "-",
        cityName: "-",
        postalCode: "-",
        addressLine1: "-",
        countryName: "-",
        addressLine2: "-",
        city: "-",
        stateProvince: "-"
      },
      contacts: [],
      name: "LAMEX Republica Dominicana"
    },
    {
      contacts: [],
      name: "PROMED Medical Logistics",
      address: {
        postalCode: "-",
        stateProvince: "-",
        country: "-",
        cityName: "-",
        city: "-",
        addressLine1: "-",
        countryName: "-",
        addressLine2: "-"
      },
      accountNumber: "9"
    }
  ]
}; 